import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Scroltotop() {
  let { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [pathname]);
  return <div></div>;
}

export default Scroltotop;
